import React from "react";

export default function CarteleraModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
      <div 
        className="bg-zinc-800 p-4 sm:p-6 rounded-2xl w-full max-w-md max-h-[90vh] overflow-y-auto scrollbar-hide text-white relative"
        style={{
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
      >
        <style jsx>{`
          .scrollbar-hide::-webkit-scrollbar {
            display: none;
          }
        `}</style>
        
        <h3 className="text-lg font-bold mb-4">Reglas</h3>
        <div className="text-sm space-y-2">
          <p>
            <strong>Al obtener el trofeo cinéfilo</strong> (se logra
            obteniendo todas las medallas y trofeos de los distintos
            rubros) podrás participar en la selección de los próximos
            estrenos en la plataforma.
          </p>
          <p className="mt-3 font-bold">
            ¿Cómo participarías? Bueno, tendrás dos opciones:
          </p>
          <ol className="list-decimal list-inside space-y-1 mt-1">
            <li>
              <strong>Puedes realizar sugerencias de nuevos títulos.</strong>
            </li>
            <li>
              <strong>Participarás en la votación de estrenos.</strong>{" "}
              Cada mes se agregará un listado de posibles estrenos dentro
              de los cuales podrás seleccionar hasta 5 de tu preferencia.
              Las películas más votadas serán agregadas a la plataforma el
              mes siguiente.
            </li>
          </ol>
        </div>
        
        <button
          onClick={onClose}
          className="mt-6 px-4 py-2 bg-yellow-400 text-black rounded-full hover:bg-yellow-300 transition w-full"
        >
          Cerrar
        </button>
      </div>
    </div>
  );
}